import graphql from './graphql';

const query = /* GraphQL */ `
  query Lesson_list($moduleId: ID!) {
    Lesson_list(moduleId: $moduleId) {
      id
      name
      isDraft
      order
      file
      duration
      address
      meetUrl
      time
      date
      description
      dateGraded
      dateAttendanceTaken
      preventTabSwitching
      LessonType {
        name
      }
      isPrivate
      isRandomQuestionOrder
    }
  }
`;

const ModuleList = async ({ moduleId }) =>
  // eslint-disable-next-line camelcase
  graphql(query, { moduleId }).then(({ Lesson_list }) => Lesson_list);

export default ModuleList;
